import PrivacyPolicyRedirectPage from './PrivacyPolicyRedirectPage';

export default PrivacyPolicyRedirectPage;
